<template lang="pug">
	div.container-fluid
		.card
			.card-header
				span.fa.fa-search.mr-2
				| Buscar clientes
			.card-body
				.row
					.col-xs-12.col-sm-12.col-md-4.col-lg-4.col-xl-4
						.form-group
							label Nombre
							input.form-control(placeholder="Buscar por nombre de cliente", v-model="filtro.nombre", @keypress.enter="buscar")
					.col-xs-12.col-sm-12.col-md-4.col-lg-4.col-xl-4
						.form-group
							label Agente
							input.form-control(placeholder="Buscar por nombre del agente", v-model="filtro.agente", @keypress.enter="buscar")
					.col-xs-12.col-sm-12.col-md-4.col-lg-4.col-xl-4
						.form-group
							label Semáforo
							br
							.btn-group
								button.btn(:class="filtro.semaforo === '' ? 'btn-primary' : ''", @click="setSemaforo('')") Todos
								button.btn(:class="filtro.semaforo === 'verde' ? 'btn-success' : 'verde'", @click="setSemaforo('verde')") Verde
								button.btn(:class="filtro.semaforo === 'naranja' ? 'btn-warning' : 'naranja'", @click="setSemaforo('naranja')") Naranja
								button.btn(:class="filtro.semaforo === 'rojo' ? 'btn-danger' : 'rojo'", @click="setSemaforo('rojo')") Rojo
			.card-footer
				button.btn.btn-primary(@click="buscar")
					span.fa.fa-search.mr-2
					| Buscar

		.card.mt-2
			.card-header
				span.fa.fa-list.mr-2
				| Clientes
			table.table.table-hover.m-0
				thead
					tr
						th ID
						th Cliente
						th Agente
						th Semáforo
						th Facturación
				tbody
					tr.cliente(
						v-for="cliente in resultados"
						:key="cliente.ID"
						@click="toggleCliente(cliente.ID)"
						:class="seleccionados.indexOf(cliente.ID) >= 0 ? 'seleccionado' : ''"
					)
						td {{cliente.ID}}
						td
							div {{cliente.cliente}}
							div(style="opacity:0.5") {{cliente.nombre_comercial}}
						td {{cliente.agenteNombre}}
						td {{cliente.dias_sin_firmar}} días
						td {{cliente.importe_facturado | currency('')}} €
		.capaAccion(:class="seleccionados.length > 0 ? 'active' : ''")
			button.btn-lg.btn.btn-primary(@click="traspasar = true")
				| Traspasar {{ seleccionados.length }} clientes

		SeleccionAgente(v-if="traspasar" @cerrar="traspasar = false", :clientes="seleccionados", @traspasado="buscar")
</template>

<script>
import axios from 'axios'
import SeleccionAgente from './seleccion-agente.component'
export default {
	components: {
		SeleccionAgente
	},
	data () {
		return {
			filtro: {
				nombre: '',
				agente: '',
				semaforo: ''
			},
			traspasar: false,
			seleccionados: [],
			resultados: []
		}
	},
	methods: {
		setSemaforo (color) {
			this.filtro.semaforo = color
			this.buscar()
		},
		toggleCliente (ID) {
			const idx = this.seleccionados.indexOf(ID)

			if (idx < 0) {
				this.seleccionados.push(ID)
			} else {
				this.seleccionados.splice(idx, 1)
			}
		},
		buscar () {
			axios.post('gestion-clientes/php/api/cartera/buscar.php', this.filtro)
				.then(res => {
					this.seleccionados = []
					this.resultados = res.data.resultados
				})
				.catch(e => {
					this.$error('Error', e.response.data.error)
				})
		}
	}
}
</script>

<style scoped>
.cliente {
	cursor: pointer;
}

.cliente.seleccionado {
	background-color: #c40303;
	color: white;
}

.capaAccion {
	position: fixed;
	display: block;
	bottom: 0;
	right: 0;
	left: 0;
	background-color: #3D4553;
	color: white;
	text-align: right;
	padding: 20px;
	transform: translateY(200px);
	transition: transform 300ms ease-in-out;
}

.capaAccion.active {
	transform: translateY(0);
}
</style>



// WEBPACK FOOTER //
// src/modulos/gestion-clientes/vue/components/traspaso-cartera/traspaso-cartera.component.vue